/**
 * Explicit column lists for Supabase SELECT queries.
 *
 * Using select('*') pulls every column including large blobs and future columns
 * added by migrations — explicit lists are faster and safer.
 *
 * Keep in sync with the matching mapRow* functions in src/repositories/supabase/.
 */

// ── Journal Entries ────────────────────────────────────────────────────────────
// All columns used by pages (LibroDiario, Balance, LibroDiarioPle, BalanceComprobacionPle)
// and the SupabaseJournalEntryRepository mapper.
export const JE_COLS =
  'id,fecha,glosa,lines,total_debe,total_haber,periodo,validated,' +
  'company_id,firm_id,posted,posted_at,is_deleted,anulada,' +
  'cuo_periodo,source,transaction_id';

// ── Transactions ───────────────────────────────────────────────────────────────
// All columns used by mapRowToDBTransaction (SupabaseTransactionRepository).
// Includes fields required for PLE generation (igv, base_imponible, tipo_documento_modificado,
// detraccion_fecha, detraccion_num_constancia) and IGV reporting.
export const TX_COLS =
  'id,fecha,descripcion,monto,base_imponible,igv,cuenta,nombre_cuenta,moneda,' +
  'status,confidence,created_at,created_by,periodo,company_id,firm_id,company_ruc,' +
  'ruc_proveedor,razon_social_proveedor,igv_revision,document_id,serie,correlativo,' +
  'tipo_documento,tipo_documento_modificado,anulada,detraccion_fecha,' +
  'detraccion_num_constancia,codigo_afectacion_igv,mapping_source,' +
  'ruc_cliente,nombre_cliente,is_deleted,fecha_vencimiento,' +
  'fecha_doc_modificado,serie_doc_modificado,correlativo_doc_modificado';

// ── Companies ──────────────────────────────────────────────────────────────────
// All columns used by mapRowToDBCompany (SupabaseCompanyRepository).
export const COMPANY_COLS =
  'db_id,firm_id,company_id,ruc,razon_social,regimen,periodo,created_by,created_at,is_deleted,' +
  'contador_whatsapp,contador_nombre,contador_email,tipo_actividad,ingresos_anuales_uit';

// ── Entities ───────────────────────────────────────────────────────────────────
// All columns used by mapRowToDBEntity (SupabaseEntityRepository).
// is_deleted: soft-delete flag — always exclude deleted entities from reads.
export const ENTITY_COLS =
  'id,firm_id,company_id,tipo_doc_identidad,numero_doc,' +
  'razon_social,razon_social_norm,tipo,cuenta_pcge,nombre_cuenta_pcge,' +
  'created_at,updated_at,is_deleted';
